import React from 'react';
import { FaCheck } from 'react-icons/fa';

/**
 * WizardProgress - Step indicator component
 * Shows progress through multi-step form
 */
const WizardProgress = ({ steps, currentStep, onStepClick, completedSteps = [] }) => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isActive = currentStep === stepNumber;
          const isCompleted = completedSteps.includes(stepNumber);
          const isClickable = isCompleted || stepNumber < currentStep;

          return (
            <React.Fragment key={stepNumber}>
              {/* Step Circle */}
              <div className="flex flex-col items-center flex-1">
                <button
                  type="button"
                  onClick={() => isClickable && onStepClick(stepNumber)}
                  disabled={!isClickable}
                  className={`
                    w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-all
                    ${isActive ? 'bg-pink-500 text-white ring-4 ring-pink-200 dark:ring-pink-900/30 scale-110' : ''}
                    ${isCompleted && !isActive ? 'bg-pink-500 text-white hover:bg-pink-600' : ''}
                    ${!isActive && !isCompleted ? 'bg-gray-200 dark:bg-spooky-bg-light text-gray-500 dark:text-gray-400' : ''}
                    ${isClickable ? 'cursor-pointer' : 'cursor-not-allowed'}
                  `}
                >
                  {isCompleted && !isActive ? (
                    <FaCheck className="text-sm" />
                  ) : (
                    stepNumber
                  )}
                </button>
                <span className={`
                  mt-2 text-xs font-medium text-center hidden sm:block
                  ${isActive ? 'text-pink-500 dark:text-pink-400' : ''}
                  ${isCompleted && !isActive ? 'text-gray-700 dark:text-gray-300' : ''}
                  ${!isActive && !isCompleted ? 'text-gray-500 dark:text-gray-400' : ''}
                `}>
                  {step.name}
                </span>
              </div>

              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className={`
                  flex-1 h-1 mx-2 transition-colors -mt-8
                  ${isCompleted ? 'bg-pink-500' : 'bg-gray-200 dark:bg-spooky-bg-light'}
                `} />
              )}
            </React.Fragment>
          );
        })}
      </div>

      {/* Mobile: Show current step name */}
      <div className="sm:hidden text-center mt-4">
        <span className="text-sm font-medium text-pink-500 dark:text-pink-400">
          {steps[currentStep - 1]?.name}
        </span>
      </div>
    </div>
  );
};

export default WizardProgress;
